export default __webpack_public_path__ + "static/media/powerball_policy.ced2b0ae.png";